import Select from 'react-select';
import { Button, Checkbox, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Box, Stack } from '@mui/system';
import { useEffect, useMemo, useState } from 'react';
import { checkNumber, emailValidation } from '../../../utilities/FormValidation';
import * as Flags from 'country-flag-icons/react/3x2';
import customStyles from 'app/shared-components/SelectCustomStyle';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import countryList from 'react-select-country-list';
import countryData from '../countries-nationality-list'
import { useParams } from 'react-router-dom';
import CustomDatePicker from '../../../utilities/CustomDatePicker';

/*--------------------------------Accordion-------------------------------------*/

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

/*------------------------------------------------------------------------------------*/

const Personal = ({ validError, setValidError, checkSubmit, onDateChange, personalInfo, currentAddress, setCurrentAddress, homeTownAddress, setHomeTownAddress,
    handlePersonalInfoChange, handleCurrentAddressChange, handleHomeTownAddressChange, setPersonalInfo, employeeRecord ,sameAddCheckBox}) => {
    const params = useParams();
    const [expanded, setExpanded] = useState('');
    const [countryOptions, setCountryOptions] = useState();
    const [currentCityOptions, setCurrentCityOptions] = useState();
    const [homeTownCityOptions, setHomeTownCityOptions] = useState();
    const [nationalityOptions, setNationalityOptions] = useState();
    const [curCallPrefix, setCurCallPrefix] = useState();
    const [homeCallPrefix, setHomeCallPrefix] = useState();

    const titleOption = [{ label: "Mr" }, { label: "Ms" }, { label: "Mrs" }];
    const maritalOption = [{ label: "Married" }, { label: "Unmarried" }, { label: "Divorced" }];

    const handleChangePanel = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    const handleTitleChange = (data) => {
        setPersonalInfo({ ...personalInfo, title: data.label });
    };
    const handleMartialStatusChange = (data) => {
        setPersonalInfo({ ...personalInfo, martialStatus: data.label });
    };

		const handleChangeUploadProfile = (e) =>{
			const file = e.target.files[0];

        var reader = new FileReader();
        reader.onload = function (upload) {
						setPersonalInfo({ ...personalInfo, profilePic: upload.target.result });
        };
        reader.readAsDataURL(file);
			
	}

    const handleChangeSelected = (checked) => {
        if (checked) {
            setHomeTownAddress(currentAddress);
        } else {
            setHomeTownAddress(
                {
                    country: "",
                    state: "",
                    city: "",
                    zipCode: "",
                    address1: "",
                    phone: "",
                    extension: "",
                    mobile: "",
                    email: "",
                }
            );
        }
    }

    const changeCurrentAddressCountry = (data) => {
        setCurrentAddress({ ...currentAddress, country: data.value });
    };
    const changeCurrentAddressCity = (data) => {
        setCurrentAddress({ ...currentAddress, city: data.label });

    }
    const changeHomeTownAddressCountry = (data) => {
        setHomeTownAddress({ ...homeTownAddress, country: data.value });
    };
    const changeHomeTownAddressCity = (data) => {
        setHomeTownAddress({ ...homeTownAddress, city: data.label });
    };
    const changeNationality = (data) => {
        setPersonalInfo({ ...personalInfo, nationality: data.label });
    };
    

    const country = async () => {
        const countryURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
        const countriesList = await OAuthService.getList(countryURL + '?size=100');
        let countries = countriesList?.data?._embedded.countries
        let result = countryData.filter((countriesData) => countries.find((countryList) => countryList.isoCode === countriesData.isoCode));
        result = result.map((value) => {
            return { label: value?.nationality, value: value?.isoCode }
        });
        setNationalityOptions(result);

        countries = countries.map((value) => {
            const Flag = Flags[value?.isoCode];
            let city_link = value._links.cities.href;
            return { label: value?.name, value: value?.name, city_link: city_link, code: value?.isoCode, icon: value?.isoCode && <Flag width={18} style={{ marginInline: "5px" }} /> }
        });
        setCountryOptions(countries);
    }

    const city = async () => {
        if (currentAddress?.country) {
            const currentCountry = countryOptions?.find((country) => country.value === currentAddress.country);
            const currentCities = await OAuthService.getList(currentCountry?.city_link + '?size=1000');
            const currentCityResult = currentCities?.data?._embedded.cities.map((value) => {
                return { label: value.cityName }
            });
            setCurrentCityOptions(currentCityResult);

        }
        if (homeTownAddress?.country) {
            const homeTownCountry = countryOptions?.find((country) => country.value === homeTownAddress.country);
            const homeTownCities = await OAuthService.getList(homeTownCountry?.city_link + '?size=1000');
            const homeTownCityResult = homeTownCities?.data?._embedded.cities.map((value) => {
                return { label: value.cityName }
            });
            setHomeTownCityOptions(homeTownCityResult);
        }


    }

    useEffect(() => {
        if(currentAddress.country){
            const countryObj = countryData.find((item)=> item.name === currentAddress.country);
            setCurCallPrefix(countryObj?.dialCode)
        }
        if(homeTownAddress){
            const countryObj = countryData.find((item)=> item.name === homeTownAddress.country);
            setHomeCallPrefix(countryObj?.dialCode)
        }
    }, [currentAddress,homeTownAddress])

    useEffect(() => {
        country();
        city();
    }, [currentAddress, homeTownAddress]);

    return (
        <div >
            <FormControl
                // ref={formRef}
                className="flex flex-col justify-center"
            >

                <Grid container spacing={2}>
                    <Grid item xs={10}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>*Trainer Id</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="employeeId"
                                        value={personalInfo.employeeId}
                                        error={(checkSubmit && !personalInfo.employeeId) || validError.employeeId ? true : false}
                                        helperText={(checkSubmit && !personalInfo.employeeId) ? "" : validError.employeeId}
                                        onChange={(e) => { handlePersonalInfoChange(e); setValidError({ ...validError, employeeId: checkNumber(e.target.value) }) }}
                                        disabled={params.id ? true : false}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>Display Name</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="displayName"
                                        required
                                        value={personalInfo.displayName}
                                        // error={(checkSubmit && !personalInfo.displayName) || validError.displayName ? true : false}
                                        // helperText={(checkSubmit && !personalInfo.displayName) ? "" : validError.displayName}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={1.5}>
                                <Stack>
                                    <label>*Select Title</label>
                                    <Select
                                        className="mb-16"
                                        name="title"
                                        value={(personalInfo.title && titleOption) && titleOption.filter(obj => personalInfo.title === obj.label)}
                                        onChange={handleTitleChange}
                                        options={titleOption}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !department) ? "" : validError.department}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={3.5}>
                                <Stack>
                                    <label>*First Name</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="empFirstName"
                                        required
                                        value={personalInfo.empFirstName}
                                        // error={(checkSubmit && !personalInfo.empFirstName) || validError.empFirstName ? true : false}
                                        // helperText={(checkSubmit && !personalInfo.empFirstName) ? "" : validError.empFirstName}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={3.5}>
                                <Stack>
                                    <label>*Middle Name</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="empMiddleName"
                                        required
                                        value={personalInfo.empMiddleName}
                                        // error={(checkSubmit && !personalInfo.empMiddleName) || validError.empMiddleName ? true : false}
                                        // helperText={(checkSubmit && !personalInfo.empMiddleName) ? "" : validError.empMiddleName}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={3.5}>
                                <Stack>
                                    <label>*Last Name</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="empLastName"
                                        required
                                        value={personalInfo.empLastName}
                                        // error={(checkSubmit && !personalInfo.empLastName) || validError.empLastName ? true : false}
                                        // helperText={(checkSubmit && !personalInfo.empLastName) ? "" : validError.empLastName}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Stack className="mb-16">
                                    <label>Nationality</label>
                                    <Select name="country"
                                        placeholder="Select Nationality"
                                        value={(nationalityOptions && personalInfo.nationality) && nationalityOptions.filter(obj => personalInfo.nationality.includes(obj.label))}
                                        onChange={changeNationality}
                                        className="select"
                                        classNamePrefix="select"
                                        options={nationalityOptions}
                                        // styles={customStyles(((checksubmit && !personalInfo.nationality) || validError.personalInfo.nationality) ? "none" : "none")}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography sx={{ color: 'red', fontSize: "1.2rem", padding: "5px 0px 0px 10px" }}>{(checksubmit && !personalInfo.nationality) ? "This field is required" : validError.personalInfo.nationality}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>Religion</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="religion"
                                        required
                                        value={personalInfo.religion}
                                        // error={(checkSubmit && !personalInfo.religion) || validError.religion ? true : false}
                                        // helperText={(checkSubmit && !personalInfo.religion) ? "" : validError.religion}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>*Date of Birth</label>
                                    <CustomDatePicker 
                                    format={'dd-MM-yyyy'}
                                    name={'dateOfBirth'}
                                    value={personalInfo?.dateOfBirth}
                                    maxDate={new Date()}
                                    handleChange={(e) => handlePersonalInfoChange(e, "dateOfBirth")}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checkSubmit && !validUntil) ? "" : validError.validUntil}</Typography> */}
                                </Stack>

                            </Grid>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>Birth Place</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="birthPlace"
                                        value={personalInfo.birthPlace}
                                        // error={(checkSubmit && !personalInfo.birthPlace) || validError.birthPlace ? true : false}
                                        // helperText={(checkSubmit && !personalInfo.birthPlace) ? "" : validError.birthPlace}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>



                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Email</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="email"
                                        value={personalInfo.email}
                                        error={(checkSubmit && !personalInfo.email) || validError.personalInfoEmail ? true : false}
                                        helperText={(checkSubmit && !personalInfo.email) ? "" : validError.personalInfoEmail}
                                        onChange={(e) => { handlePersonalInfoChange(e); setValidError({ ...validError, personalInfoEmail: emailValidation(e.target.value) }) }}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Select Marital Status</label>
                                    <Select
                                        className="mb-16"
                                        name="martialStatus"
                                        value={(personalInfo.martialStatus && maritalOption) && maritalOption.filter(obj => personalInfo.martialStatus === obj.label)}
                                        onChange={handleMartialStatusChange}
                                        options={maritalOption}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !department) ? "" : validError.department}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack sx={{ marginBottom: "10px" }}>
                                    <label id="demo-row-radio-buttons-group-label">*Gender</label>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="gender"
                                        value={personalInfo.gender}
                                        onChange={(e) => handlePersonalInfoChange(e)}
                                    >
                                        <FormControlLabel value="Female" control={<Radio />} label="Female" />
                                        <FormControlLabel value="Male" control={<Radio />} label="Male" />
                                    </RadioGroup>
                                </Stack>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item xs={2}>
                        <Box spacing={2} className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey', textAlign:"right" }}>
                            <div className="flex items-end justify-end mb-24 flex-col">
                                <img
                                    className="w-[110px] h-[150px]"
                                 src={personalInfo.profilePic ? personalInfo.profilePic : "/assets/images/avatars/default_profile.jpg"}
                                alt={"profile picture"}
                                />
      												{/* <Avatar
      												  sx={{
      												    backgroundColor: "background.paper",
      												    color: "text.secondary",
      												  }}
      												  className="avatar text-32 font-bold w-96 h-96"
      												  src={personalInfo.profilePic}
      												>
      												</Avatar> */}
																	<Button
																		// onClick={handleSubmit}
																		className='mt-16'
																		variant="contained"
																		component="label"
																		color="secondary"
																		size="small"
																	>
																		<input hidden accept="image/*" type="file"
																					onChange={(e) => handleChangeUploadProfile(e)}
																			/>
                    								{/* <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon> */}
																			<Typography color="black" >Upload Profile</Typography>
                									</Button>
													{/* <Button
																			variant="contained"
																			component="label"
																			color="warning"
																			className='ml-12'
																	>
																			<input hidden type="file"
																					onChange={(e) => handleDocumentChange(e)}
																			/>
																			<Typography color="black">Browse</Typography>
																	</Button> */}
                                
                                {/* {user.data.displayName.charAt(0)} */}
                            </div>
                            <div>
                                <Typography>
                                    {`${personalInfo.empFirstName} ${personalInfo.empMiddleName} ${personalInfo.empLastName}`}
                                </Typography>
                                <Typography>
                                    {employeeRecord.designation}
                                </Typography>
                                <Typography className='mb-16'>
                                    {"Nolte FZE Dubai Silicon Oasis"}
                                </Typography>
                                <Typography color="text.secondary">
                                {currentAddress.mobile && curCallPrefix ? `${curCallPrefix} ${currentAddress.mobile}` : ""}
                                </Typography>
                                <Typography color="text.secondary">
                                    {homeTownAddress.mobile && homeCallPrefix ? `${homeCallPrefix} ${homeTownAddress.mobile}` : ""}
                                </Typography>
                                <Typography color="text.secondary">
                                    {personalInfo.email}
                                </Typography>

                            </div>

                        </Box>



                    </Grid>
                </Grid>


            </FormControl>

            <div>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChangePanel('panel1')}>
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                        <Typography>Address</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Grid className='flex items-center'>
                                    <Typography >Current Address</Typography>

                                </Grid>
                                <Box spacing={2} className="mb-20 mt-24" sx={{ p: 2, border: '1px dashed grey' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack className="mb-16">
                                                <label>Country</label>
                                                <Select name="country"
                                                    placeholder="Select Country"
                                                    value={(countryOptions && currentAddress?.country) && countryOptions.filter(obj => currentAddress?.country.includes(obj.value))}
                                                    onChange={changeCurrentAddressCountry}
                                                    className="select"
                                                    classNamePrefix="select"
                                                    options={countryOptions}
                                                    getOptionLabel={e => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {e.icon}
                                                            <span style={{ marginLeft: 5 }}>{e.label}</span>
                                                        </div>
                                                    )}
                                                    // styles={customStyles(((checksubmit && !currentAddress?.country) || validError.currentAddress?.country) ? "none" : "none")}
                                                    styles={customStyles()}
                                                />
                                                {/* <Typography sx={{ color: 'red', fontSize: "1.2rem", padding: "5px 0px 0px 10px" }}>{(checksubmit && !currentAddress?.country) ? "This field is required" : validError.currentAddress?.country}</Typography> */}
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>State</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="state"
                                                    value={currentAddress.state}
                                                    // error={(checkSubmit && !currentAddress.state) || validError.state ? true : false}
                                                    // helperText={(checkSubmit && !currentAddress.state) ? "" : validError.state}
                                                    onChange={(e) => handleCurrentAddressChange(e)}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack className="mb-16">
                                                <label>City</label>
                                                <Select name="city"
                                                    placeholder="Select City"
                                                    value={(currentCityOptions && currentAddress?.city) && currentCityOptions.filter(obj => currentAddress?.city.includes(obj.label))}
                                                    onChange={changeCurrentAddressCity}
                                                    className="select"
                                                    classNamePrefix="select"
                                                    options={currentCityOptions}
                                                    styles={customStyles()}
                                                />
                                            </Stack>


                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Zip code</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="zipCode"
                                                    value={currentAddress.zipCode}
                                                    error={(checkSubmit && !currentAddress.zipCode) || validError.currentAddressZipCode ? true : false}
                                                    helperText={(checkSubmit && !currentAddress.zipCode) ? "" : validError.currentAddressZipCode}
                                                    onChange={(e) => { handleCurrentAddressChange(e); setValidError({ ...validError, currentAddressZipCode: checkNumber(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <Stack>
                                        <label>Address</label>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="address1"
                                            value={currentAddress.address1}
                                            // error={(checkSubmit && !currentAddress.address) || validError.address ? true : false}
                                            // helperText={(checkSubmit && !currentAddress.address) ? "" : validError.address}
                                            onChange={(e) => handleCurrentAddressChange(e)}
                                            variant="outlined"
                                        />
                                    </Stack>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Phone</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="phone"
                                                    value={currentAddress.phone}
                                                    error={(checkSubmit && !currentAddress.phone) || validError.currentAddressPhone ? true : false}
                                                    helperText={(checkSubmit && !currentAddress.phone) ? "" : validError.currentAddressPhone}
                                                    onChange={(e) => { handleCurrentAddressChange(e); setValidError({ ...validError, currentAddressPhone: checkNumber(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Extension</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="extension"
                                                    required
                                                    value={currentAddress.extension}
                                                    // error={(checkSubmit && !currentAddress.extension) || validError.extension ? true : false}
                                                    // helperText={(checkSubmit && !currentAddress.extension) ? "" : validError.extension}
                                                    onChange={(e) => handleCurrentAddressChange(e)}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>

                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Mobile Number</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="mobile"
                                                    value={currentAddress.mobile}
                                                    error={(checkSubmit && !currentAddress.mobile) || validError.currentAddressMobile ? true : false}
                                                    helperText={(checkSubmit && !currentAddress.mobile) ? "" : validError.currentAddressMobile}
                                                    onChange={(e) => { handleCurrentAddressChange(e), setValidError({ ...validError, currentAddressMobile: checkNumber(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Email</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="email"
                                                    required
                                                    value={currentAddress.email}
                                                    error={(checkSubmit && !currentAddress.email) || validError.currentAddressEmail ? true : false}
                                                    helperText={(checkSubmit && !currentAddress.email) ? "" : validError.currentAddressEmail}
                                                    onChange={(e) => { handleCurrentAddressChange(e); setValidError({ ...validError, currentAddressEmail: emailValidation(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                {/* <div className='flex'> */}
                                <div className='flex justify-between'>
                                    <Grid className='flex items-center'>
                                        <Typography>Hometown Address</Typography>

                                    </Grid>
                                    <Grid>

                                        <FormControlLabel
                                            checked={sameAddCheckBox}
                                            control={
                                                <Checkbox
                                                    onChange={(e) => handleChangeSelected(e.target.checked)}
                                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 16 }, '.MuiFormControlLabel-label': { fontSize: 12 } }}
                                                />}
                                            label="Same as current address" />
                                    </Grid>

                                </div>
                                {/* <FormGroup >
                                </FormGroup> */}
                                {/* </div> */}
                                <Box spacing={2} className="mb-20 mt-16" sx={{ p: 2, border: '1px dashed grey' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack className="mb-16">
                                                <label>Country</label>
                                                <Select name="country"
                                                    placeholder="Select Country"
                                                    value={(countryOptions && homeTownAddress?.country) && countryOptions.filter(obj => homeTownAddress?.country.includes(obj.value))}
                                                    onChange={changeHomeTownAddressCountry}
                                                    className="select"
                                                    classNamePrefix="select"
                                                    options={countryOptions}
                                                    getOptionLabel={e => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {e.icon}
                                                            <span style={{ marginLeft: 5 }}>{e.label}</span>
                                                        </div>
                                                    )}
                                                    // styles={customStyles(((checksubmit && !homeTownAddress?.country) || validError.homeTownAddress?.country) ? "none" : "none")}
                                                    styles={customStyles()}
                                                />
                                                {/* <Typography sx={{ color: 'red', fontSize: "1.2rem", padding: "5px 0px 0px 10px" }}>{(checksubmit && !homeTownAddress?.country) ? "This field is required" : validError.homeTownAddress?.country}</Typography> */}
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>State</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="state"
                                                    value={homeTownAddress.state}
                                                    // error={(checkSubmit && !homeTownAddress.state) || validError.state ? true : false}
                                                    // helperText={(checkSubmit && !homeTownAddress.state) ? "" : validError.state}
                                                    onChange={(e) => handleHomeTownAddressChange(e)}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack className="mb-16">
                                                <label>City</label>
                                                <Select name="city"
                                                    placeholder="Select City"
                                                    value={(homeTownCityOptions && homeTownAddress?.city) && homeTownCityOptions.filter(obj => homeTownAddress?.city.includes(obj.label))}
                                                    onChange={changeHomeTownAddressCity}
                                                    className="select"
                                                    classNamePrefix="select"
                                                    options={homeTownCityOptions}
                                                    styles={customStyles()}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Zip code</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="zipCode"
                                                    value={homeTownAddress.zipCode}
                                                    error={(checkSubmit && !homeTownAddress.zipCode) || validError.homeTownAddressZipCode ? true : false}
                                                    helperText={(checkSubmit && !homeTownAddress.zipCode) ? "" : validError.homeTownAddressZipCode}
                                                    onChange={(e) => { handleHomeTownAddressChange(e); setValidError({ ...validError, homeTownAddressZipCode: checkNumber(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <Stack>
                                        <label>Address</label>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="address1"
                                            value={homeTownAddress.address1}
                                            // error={(checkSubmit && !homeTownAddress.address) || validError.address ? true : false}
                                            // helperText={(checkSubmit && !homeTownAddress.address) ? "" : validError.address}
                                            onChange={(e) => handleHomeTownAddressChange(e)}
                                            variant="outlined"
                                        />
                                    </Stack>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Phone</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="phone"
                                                    value={homeTownAddress.phone}
                                                    error={(checkSubmit && !homeTownAddress.phone) || validError.homeTownAddressPhone ? true : false}
                                                    helperText={(checkSubmit && !homeTownAddress.phone) ? "" : validError.homeTownAddressPhone}
                                                    onChange={(e) => { handleHomeTownAddressChange(e); setValidError({ ...validError, homeTownAddressPhone: checkNumber(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Extension</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="extension"
                                                    required
                                                    value={homeTownAddress.extension}
                                                    // error={(checkSubmit && !homeTownAddress.extension) || validError.extension ? true : false}
                                                    // helperText={(checkSubmit && !homeTownAddress.extension) ? "" : validError.extension}
                                                    onChange={(e) => handleHomeTownAddressChange(e)}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>

                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Mobile Number</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="mobile"
                                                    value={homeTownAddress.mobile}
                                                    error={(checkSubmit && !homeTownAddress.mobile) || validError.homeTownAddressMobile ? true : false}
                                                    helperText={(checkSubmit && !homeTownAddress.mobile) ? "" : validError.homeTownAddressMobile}
                                                    onChange={(e) => { handleHomeTownAddressChange(e); setValidError({ ...validError, homeTownAddressMobile: checkNumber(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Stack>
                                                <label>Email</label>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="email"
                                                    required
                                                    value={homeTownAddress.email}
                                                    error={(checkSubmit && !homeTownAddress.email) || validError.homeTownAddressEmail ? true : false}
                                                    helperText={(checkSubmit && !homeTownAddress.email) ? "" : validError.homeTownAddressEmail}
                                                    onChange={(e) => { handleHomeTownAddressChange(e); setValidError({ ...validError, homeTownAddressEmail: emailValidation(e.target.value) }) }}
                                                    variant="outlined"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>

            </div>
        </div>
    )
}

export default Personal